// Home.jsx
import React, { useState, useEffect } from 'react';
import GlassBox from '../GlassBox/GlassBox';
import AccessibilityPanel from '../AccessibilityPanel/AccessibilityPanel';
import homeImg from '../../assets/home_img.png';

const Home = ({ onLoginClick }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    // Preload the background image
    const img = new Image();
    img.src = homeImg;
    img.onload = () => setImageLoaded(true);
    
    // Set loaded immediately to prevent flash
    setImageLoaded(true);
  }, []);

  return (
    <div className={`HomeImg ${imageLoaded ? 'image-loaded' : 'image-loaded'}`}>
      <GlassBox onLoginClick={onLoginClick} />
      <AccessibilityPanel />
    </div>
  );
};

export default Home;
